
    import {Component, Vue} from 'vue-property-decorator';

    @Component<HowItWorks>({
        metaInfo()
        {
            return {
                title: 'Jak to funguje',
                titleTemplate: '%s | Půjčovna Haryků',
            };
        },
    })
    export default class HowItWorks extends Vue
    {
    }
